import React, { FC } from "react";
// libs
import Modal from "react-modal";
import NextImage from "next/image";
import Mapbox from "src/components/ui/Map";
// const
import { MAP_MODAL } from "src/constants/modals";
// hooks
import { useModal, useAppSelector } from "src/hooks";
// redux
import { modalSelector } from "src/redux/slices";
// types
import { IModalMapProps } from "./map.types";
import { MobileViewMapButton, MobileViewMapButtonText } from "./map.styles";

const ModalMap: FC<IModalMapProps> = ({ containerProps }) => {
  const { closeModal } = useModal();
  const { isOpen } = useAppSelector(modalSelector(MAP_MODAL));

  const handleCloseModal = () => closeModal(MAP_MODAL);

  return (
    <Modal
      isOpen={isOpen}
      style={{
        overlay: {
          zIndex: 3000,
        },
        content: {
          padding: 0,
          width: "100vw",
          height: "100vh",
          top: 0,
          left: 0,
        },
      }}
      contentLabel="Map modal"
      ariaHideApp={false}
    >
      {containerProps && <Mapbox containerProps={containerProps} />}

      <MobileViewMapButton onClick={handleCloseModal}>
        <NextImage src="/icons/list-white.svg" width={18} height={10} layout="fixed" />
        <MobileViewMapButtonText>View list</MobileViewMapButtonText>
      </MobileViewMapButton>
    </Modal>
  );
};

export default ModalMap;
